import { useCallback } from 'react'
import { Action } from 'stores/Workflows/Action'
import { TransitionEffectPayload } from 'utils/workflows/runAfterTransitionEffects'
import { AssigneeType } from '../api/clients/PropertyClient'
import { State } from '../stores/Workflows/State'
import { Assignee, useExecuteWorkflowActions } from './useExecuteWorkflowActions'

export const runnableActions = (assignee: Assignee, actions: Action[]) => {
  if (assignee.type === AssigneeType.Article) {
    return actions
  }

  return actions.filter((action) => ['files.move', 'files.copy', 'accesses.create'].includes(action.type))
}

export const useWorkflowTransition = () => {
  const executeActions = useExecuteWorkflowActions()

  return useCallback(
    async (assignee: Assignee, from: State, to: State) => {
      let payloads: TransitionEffectPayload = {}

      const exitActions = runnableActions(assignee, from.exitActions)
      const context = {
        assignee,
        currentState: from,
        nextState: to,
      }

      if (exitActions.length > 0) {
        const exitPayloads = await executeActions(exitActions, context)

        payloads = Object.assign(payloads, ...exitPayloads)

        if (Object.values(payloads).some((payload) => payload === null)) {
          return payloads
        }
      }

      const entryActions = runnableActions(assignee, to.entryActions)

      if (entryActions.length > 0) {
        const entryPayloads = await executeActions(entryActions, context)
        payloads = Object.assign(payloads, ...entryPayloads)
      }

      return payloads
    },
    [executeActions],
  )
}
